<template>
  <div class="share-check">
    <div class="share-header">
      <i class="icon-czur-logo"></i>
    </div>
    <div class="share-box" :class="{'show': !loading&&!showNoFile}">
      <img src="../../assets/images/logo.png" alt="">
      <div class="share-message">
        <span class="share-text" v-if="lang === 'en'">{{$t('share.shared') + userName}}</span>
        <span class="share-text" v-else-if="lang === 'ru_RU'">{{$t('share.shared') + userName}}</span>
        <span class="share-text" v-else>{{userName}}{{$t('share.shared')}}</span>
      </div>
      <div class="share-code">
        <input class="input-pwd" :class="{'error': inputRequire}" type="text" v-model="code" v-on:input="inputOnchange" :placeholder="$t('share.enterPassword')" v-on:keyup.enter="checkCode">
        <div class="verify-msg" v-if="verifyMsg">{{codeMsg}}</div>
        <i class="icon-login-btn" v-if="showCheckBtn" @click="checkCode"></i>
        <div class="check-loading" :class="{'show': checking}">
          <div class="container">
            <loading :loading="true"></loading>
          </div>
        </div>
      </div>
    </div>
    <div class="request-box" :class="{'show': loading}">
      <div class="ball-pulse">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="check-result" v-if="showNoFile">
      <!-- 没有文件 -->
      <div class="no-file">
        <div class="no-file-main">
          <img src="../../assets/images/no_file.png" alt="">
          <div>{{fileMessage}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import Loading from '../Loading'
export default {
  name: 'shareCheck',
  components: {
    Loading
  },
  data () {
    return {
      userName: 'CZUR',
      code: '',
      verifyMsg: false,
      showCheckBtn: true,
      checking: false,
      loading: true,
      showNoFile: false,
      fileMessage: this.$t('share.fileDelete'),
      inputRequire: false,
      codeMsg: '',
      lang: ''
    }
  },
  created () {
    if (this.$i18n.locale === 'en') {
      this.lang = 'en'
    }
    if (this.$i18n.locale === 'ru_RU') {
      this.lang = 'ru_RU'
    }
    this.preCheck()
  },
  methods: {
    preCheck: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/file/public/preValidateShareFileLink?groupId=' + this.$route.params.shareId, this).then((response) => {
        this.loading = false
        if (response.code === Config.R_CODE.SHARE_NO_FILE) {
          this.showNoFile = true
          this.fileMessage = this.$t('share.fileDelete')
        } else if (response.code === Config.R_CODE.SHARE_EXPIRED_FILE) {
          this.showNoFile = true
          this.fileMessage = this.$t('share.fileExpired')
        } else if (response.code === Config.R_CODE.SUCCESS) {
          this.showNoFile = false
          this.userName = response.body.userName
        }
      })
    },
    checkCode: function () {
      // console.log(this.$route.params.shareId)
      if (this.code === '') {
        this.inputRequire = true
        return
      }
      this.showCheckBtn = false
      this.checking = true
      HttpClient.getData(Config.APP_HOST + '/v1/file/public/validateShareFileLink?groupId=' + this.$route.params.shareId + '&code=' + this.code, this).then((response) => {
        console.log(response)
        this.checking = false
        if (response.code === Config.R_CODE.SHARE_CODE_ERROR) {
          this.verifyMsg = true
          this.codeMsg = this.$t('share.wrongPassword')
        } else if (response.code === Config.R_CODE.SHARE_CODE_MANYTIME) {
          this.codeMsg = this.$t('share.wrongPassword')
          this.verifyMsg = true
        } else if (response.code === Config.R_CODE.SHARE_EXPIRED_FILE) {
          this.codeMsg = this.$t('share.fileExpired')
          this.verifyMsg = true
        } else if (response.code === Config.R_CODE.SUCCESS) {
          Config.setLocalStore('shareCode', this.code)
          this.$router.push('/share/et/' + this.$route.params.shareId + '/list')
        }
      })
    },
    inputOnchange: function () {
      this.verifyMsg = false
      this.showCheckBtn = true
      this.inputRequire = false
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
body,html
  height 100%
.share-check
  position relative
  display flex
  flex-direction row
  justify-content center
  align-items center
  width 100%
  min-height 100%
  height 100%
  background-color #fafafa
  .share-header
    position absolute
    display flex
    flex-direction row
    align-items center
    width 100%
    height 110px
    top 0px
    left 0px
    padding 0px 40px
    box-sizing border-box
    .icon-czur-logo
      font-size 35px
      color #3d3d3d
  .check-result
    position relative
    width 300px
    height 290px
  .share-box, .request-box
    display none
    flex-direction column
    align-items center
    width 300px
    height 290px
    &.show
      display flex
    .share-message
      display block
      width 100%
      padding 18px 0px 50px
      text-align center
      .share-text
        font-weight bold
        font-size 18px
        color #999999
    .share-code
      position relative
      display block
      width 100%
      height 80px
      input
        display block
        width 300px
        height 40px
        padding 0 15px
        box-sizing border-box
        background-color #ffffff
        border none
        outline none
        box-shadow 0px 0px 20px 0px rgba(39, 47, 68, 0.05)
        color #3d3d3d
        font-size 14px
        border-radius 6px
        &:-webkit-autofill
          background-color transparent
          transition background-color 50000s ease-in-out 0s
        &.input-pwd
          border-radius 6px
          &::-ms-clear
            display none
        &.error
          border 1px solid #e36868
      .verify-msg
        color #e36868
        position absolute
        top 13px
        right 14px
        font-size 14px
      .icon-login-btn
        color #3d3d3d
        font-size 26px
        position absolute
        top 7px
        right 7px
        cursor pointer
        &:hover
          opacity 0.8
      .check-loading
        position absolute
        display none
        top 25px
        right -8px
        width 26px
        height 26px
        &.show
          display block
.ball-pulse
  margin-top 40%
  div
    background-color #3d3d3d
    width 15px
    height 15px
    border-radius 100%
    margin 30px 2px
    animation-fill-mode both
    display inline-block
    &:nth-child(1)
      animation scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)
    &:nth-child(2)
      animation scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)
    &:nth-child(3)
      animation scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)
@keyframes scale
  0%
    transform scale(1)
    opacity 1
  45%
    transform scale(0.1)
    opacity 0.7
  80%
    transform scale(1)
    opacity 1
</style>



// WEBPACK FOOTER //
// src/components/Et/ShareCheck.vue